import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsApplicationAreas: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREAS,
	},
	createRegulationsApplicationArea: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].CREATE_REGULATIONS_APPLICATION_AREA,
	},
	getRegulationsApplicationArea: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREA,
	},
	patchRegulationsApplicationArea: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PATCH_REGULATIONS_APPLICATION_AREA,
	},
	putRegulationsApplicationArea: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PUT_REGULATIONS_APPLICATION_AREA,
	},
	deleteRegulationsApplicationArea: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].DELETE_REGULATIONS_APPLICATION_AREA,
	},
}